<template>
  <layout :drawerShow="_isDesktop()" :drawerWidth="350">
    <template slot="nav">
      <v-tabs>
        <v-tab :to="{ name: 'listleads' }">Leads</v-tab>
      </v-tabs>
    </template>
    <template slot="nav-tools">
      <v-btn v-if="selectedRows.length>0"
             color="error" depressed small
             class="mr-2" secondary tertiary
             @click="closeSelectedRows"
      >
        <v-icon small color="white" class="mr-1">mdi-alert-circle</v-icon>

        Clore {{ selectedRows.length }}
      </v-btn>

      <smart-btn small class="mr-3"
                 @click.native="createLead()"
      >
        <v-icon>mdi-folder-plus</v-icon>
        <span class="pl-1 d-none d-sm-flex">Nouveau lead</span>
      </smart-btn>
    </template>
    <template slot="drawer">
      <v-form ref="searchform" v-if="searchform" @submit.prevent="search">
        <v-row no-gutters class="pt-2 pr-1">

          <v-col cols="12" class="pr-1 mt-2">
            <smart-multi-select
                v-model="searchform.virtualSites"
                label="Sites"
                :items="virtualSites"
                all-is-same-as-empty
                default-select-all
            ></smart-multi-select>
          </v-col>
        </v-row>
        <v-row no-gutters class="pt-2 pr-1 mt-2">
          <v-col cols="12" class>
            <v-subheader light class="pa-0 mt-3 mb-0 mx-0 form-subheader">Date de création</v-subheader>
            <v-divider class="mb-1"></v-divider>
          </v-col>

          <v-col class="pr-1 " cols="6">
            <smart-picker
                v-model="searchform.startDate"
                :stopDate="searchform.stopDate"
                :inputOpts="{ label: $t('begin') }"
            />
          </v-col>
          <v-col cols="6" class="">
            <smart-picker
                v-model="searchform.stopDate"
                :startDate="searchform.startDate"
                :inputOpts="{ label: $t('end') }"
            />
          </v-col>

        </v-row>
        <v-row no-gutters class="pt-2 pr-1 mt-2">
          <v-col cols="12" class>
            <v-subheader light class="pa-0 mb-1 mx-0 form-subheader">
              Client
            </v-subheader>
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12">
            <v-text-field
                clearable
                v-model="searchform.client"
                label="Nom, Email"
                placeholder=" "
                hide-details
                class=""
            >
            </v-text-field>
          </v-col>
        </v-row>

        <v-row no-gutters class="pt-2 pr-1 mt-2">
          <v-col cols="12">
            <v-select
                v-model="searchform.userId"
                label="Utilisateurs"
                item-text="name"
                item-value="id"
                :items="users"
            />
          </v-col>
        </v-row>

        <v-row no-gutters class="pt-2 pr-1 mt-2">
          <v-col cols="6" class="mt-2">
            <v-subheader light class="pa-0 mb-1 mx-0 form-subheader"
            >Statut de lead
            </v-subheader
            >
            <v-divider class="mb-1"></v-divider>
          </v-col>
          <v-col cols="6" class="mt-2">
            <v-subheader light class="pa-0 mb-1 mx-0 form-subheader"
            >Score du lead
            </v-subheader
            >
            <v-divider class="mb-1"></v-divider>
          </v-col>
          <v-col cols="6">
            <v-checkbox
                v-for="(bs, index) in leadStatus"
                :key="'bs-' + index"
                v-model="searchform.status"
                :label="bs.label"
                :value="bs.value"
                :class="'pt-1 ' + (index == 0 ? 'mt-2' : 'mt-0')"
                height="1"
                multiple
            >
            </v-checkbox>
          </v-col>
          <v-col cols="6" class="d-flex flex-column justify-start">
            <div v-for="(_,i) in 3" :key="i" class="d-flex align-center" style="height:1.7em">
              <v-checkbox v-model="searchform.scores" :value="i" multiple/>
              <score-lead :score="i"/>
            </div>

          </v-col>
        </v-row>

        <v-row no-gutters class="pt-2 pr-1 mt-2">
          <smart-btn class="mt-3"
                     :disabled="!formValid || loading"
                     :loading="loading"
                     type="submit"
                     block
                     primary
          >Rechercher
          </smart-btn
          >
          <smart-btn
              block
              tertiary
              @click.native="resetForm"
          >Réinitialiser la recherche
          </smart-btn
          >
        </v-row>
      </v-form>
    </template>
    <template slot="content">

      <div v-if="detectExtensionDone" class="mt-2">
        <v-alert v-if="!extension.installed" type="info" outlined class="mr-10 ml-10">
          Il semblerait que l'extension d'aide à la création de Lead depuis le site Hotelissima.fr n'est pas installée sur cet ordinateur.<br />
          <v-btn @click="openExtensionUrl" outlined small color="primary" class="justify-center">Ajouter l'extension à mon navigateur</v-btn>
        </v-alert>
        <v-alert  v-if="extension.installed && extension.installedVersion !== extension.lastVersion"
                 type="info" outlined class="mr-10 ml-10">
          L'extension Hotelissima n'est pas à jour<br />
          <v-btn @click="openExtensionUrl" outlined small color="primary" class="justify-center">Mettre à jour mon extension</v-btn>
        </v-alert>
      </div>

      <div class="pa-3">
        <leads-list-table
            :leadsList="leads"
            :selected-rows.sync="selectedRows"
        />
      </div>
      <smart-dialog
          v-model="newLeadModal"
          title="Nouveau Lead">
        <LeadCreationDialog @done="(item) => closeNewLeadModal(item)"/>
        <template title="actions">
          <v-card-actions class="actions-btn mt-4">
            <v-spacer/>
            <smart-btn type="submit" form="creation-lead">
              <v-icon small class="mr-1">mdi-content-save</v-icon>
              Créer
            </smart-btn>
          </v-card-actions>
        </template>
      </smart-dialog>
    </template>
  </layout>
</template>
<script>
import Layout from "@/views/Layout.vue";
import {get, post} from "@/utils/api";
import FormMixin from "@/components/mixins/FormMixin";
import SiteLabel from "@/components/commons/SiteLabel.vue";
import SmartSelect from "@/components/commons/SmartSelect.vue";
import ScoreLead from "@/components/booking/ScoreLead.vue";
import LeadCreationDialog from "@/views/lead/LeadCreationDialog.vue";
import {EventBus} from "@/components/commons/event-bus";
import LeadsListTable from "@/views/lead/leads-list-table.vue";
import SmartMultiSelect from "@/components/commons/SmartMultiSelect.vue";

export default {
  components: {
    SmartMultiSelect,
    LeadsListTable,
    ScoreLead,
    Layout,
    LeadCreationDialog
  },
  mixins: [FormMixin],
  data() {
    return {
      users: [],
      searchform: {
        startDate: null,
        stopDate: null,
        destinations: [],
        status: [],
        client: null,
        scores: [],
        userId: [],
        virtualSites:[]
      },
      defaultSearchform: {
        startDate: this._formatDate(this._subDays(new Date(), 30), "dd/MM/yyyy"),
        stopDate: this._formatDate(new Date(), "dd/MM/yyyy"),
        destinations: [],
        status: ["open"],
        scores: [],
        userId: [],
        virtualSites:[]
      },
      leadStatus: [
        {label: "Ouvert", value: 'open'},
        {label: "Clos", value: 'close'},
        {label: "Attente client", value: 'pending'}
      ],
      virtualSites: [],
      loading: false,
      newLeadModal: false,
      leads: [],

      detectExtensionDone:false,
      extension:{
        installed: false,
        installedVersion: null,
        lastVersion: "1.5.3"
      },

      selectedRows:[]
    }
  },
  mounted() {
    get("/api/search/users").json(rs => {
      const res = rs.filter(u => u.groups.some(g => g.id == 3))
      this.users = [{name: "Tous", id: -1}, ...res]
    })
    this.search()
    EventBus.$on("reloadListLead", () => {
      this.search()
    });

    setTimeout(() => {
      this.initExtensionDetection()
    }, 4000)

    setTimeout(() => {
      this.detectExtensionDone = true //to show if no messages received
    }, 5000)
  },
  created() {
    this.initSearchform()
    get("/api/search/virtual-sites").json((sites) => {
      this.virtualSites = sites.filter(s =>
          !s.id.includes("B2B") &&
          !s.id.includes("HResa") &&
          !s.id.includes("Evao")  );
      this.defaultSearchform.virtualSites = this.virtualSites.map(
          (s) => s.id
      );
    })
  },
  destroyed() {
    EventBus.$off("reloadListLead");
  },
  computed: {
    formValid() {
      return this.searchform.startDate != null && this.searchform.stopDate != null
    }
  },
  methods: {
    initSearchform() {
      const qs = new URLSearchParams(window.location.search);
      const search = (() => {
        try {
          return JSON.parse(qs.get("search"));
        } catch (e) {
          return null;
        }
      })();

      if (search) {
        this.searchform = search;
      } else this.clearSearchform();

      this.searchform.userId = this.isAdmin ? -1 : this.currentUser.id
    },
    clearSearchform() {
      this.searchform = {...this.defaultSearchform};
    },

    closeNewLeadModal(lead) {
      this.newLeadModal = false
      this.toLead(lead)
    },

    search() {
      window.history.pushState(
          "",
          "",
          "?search=" + JSON.stringify(this.searchform)
      );
      this.loading = true
      this.leads = []
      this.selectedRows = []
      const body = {
        startDate: this._parseAndFormatDate(this.searchform.startDate, "dd/MM/yyyy", "yyyy-MM-dd"),
        stopDate: this._parseAndFormatDate(this.searchform.stopDate, "dd/MM/yyyy", "yyyy-MM-dd"),
        destinations: [],
        virtualSites: this.searchform.virtualSites,
        status: this.searchform.status,
        client: this.searchform.client,
        scores: this.searchform.scores,
        userId: this.searchform.userId == -1 ? null : this.searchform.userId,
      }
      post('/api/lead/list', body)
          .json(data => {
            this.leads = data
          })
          .finally(() => {
            this.loading = false
          })
    },
    toLead(lead, newTab) {
      if (newTab) {
        let route = this.$router.resolve({
          name: "lead",
          params: {id: lead.id},
        });
        window.open(route.href, "_blank");

      } else {
        this.$router.push({name: "lead", params: {id: lead.id}});
      }
    },
    createLead() {
      this.newLeadModal = true
    },
    resetForm() {
      this.defaultSearchform.userId = this.isAdmin ? -1 : this.currentUser.id
      this.searchform = this.defaultSearchform
    },

    initExtensionDetection() {
      const handlerExtension = (event) => {
        if (event.origin !== window.location.origin || event.data?.type !== 'EXTENSION_PONG')
          return;

        this.detectExtensionDone = true
        window.removeEventListener('message', handlerExtension)

        this.extension = {
          ...this.extension,
          installed: true,
          installedVersion: event.data.version
        }
      }

      window.addEventListener('message', handlerExtension)

      setTimeout(() => {}, 1000)

      window.postMessage({
        type: 'EXTENSION_PING',
      }, window.location.origin)
    },
    openExtensionUrl() {
      window.open('https://chromewebstore.google.com/detail/hotelissima-toolbox/mhkjdppkdhggoeknfpdiccaggbodolen?authuser=0&hl=fr', '_blank')
      return false
    },
    closeSelectedRows() {
      if (this.selectedRows.length === 0) return;

      let errors = [];
      const futureClose = this.selectedRows.map(sr => {
        return get(`/api/lead/${sr.id}/close/missing`)
        .badRequest(err => {
          errors.push(err.toString());
        })
        .res(() => {
        })
        .then(() => errors)
      })

      return Promise.all(futureClose).then(errors => {
        if (errors.length === 0 ) {
          EventBus.$emit('toaster-msg', "Suppression enregistrée")
        } else {
          EventBus.$emit('toaster-msg', errors.join('\n'))
        }

        this.selectedRows = []
        this.search()
      });
    }
  }

}
</script>